import {ThemeProvider} from "styled-components";
import {OrbitComponent} from "../base-components/orbit-component/orbit-component";
import {ToasterStyleWrapper} from './boxes/toaster-styles-wrapper.box';
import {ToastContainerBox} from './boxes/toast-container/toast-container.box';
import 'react-toastify/dist/ReactToastify.css';

export class ToasterComponent extends OrbitComponent {
    render() {
        return (<ThemeProvider theme={this.services.theme.toastersTheme}>
            <ToasterStyleWrapper>
                <ToastContainerBox
                    position={this.services.mediaQuery.mAndBelow ? "top-center" : (this.services.language.isRTLLanguage ? "bottom-left" : "bottom-right")}
                    closeOnClick={false}
                    rtl={this.services.language.isRTLLanguage}
                    autoClose={5000}
                    hideProgressBar={false}
                    newestOnTop={false}
                    pauseOnFocusLoss
                    draggable
                    pauseOnHover
                    /* Because I am wrapping ToastContainer in a styled component, we won't be able to use the theme prop to set "dark", "light" or "colored".
                    * Theme will be set by the styled-components library to OrbitTheme.
                    * However, when dispatching a toast we can specify the theme in the options parameter: toast.custom(<SomeCustomContent />, {theme: "dark"});
                    * default is "light" */
                    // theme="light"
                />
            </ToasterStyleWrapper>
        </ThemeProvider>);
    }
}
